import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { accountSettingsApi } from './api/account-settings';
import { billingApi } from './api/billing';
import { leadersApi } from './api/leaders';
import { managementCategoriesApi } from './api/management/managementCategories';
import { managementScheduleApi } from './api/management/managementSchedule';
import { metadataApi } from './api/metadata';
import { organizationApi } from './api/organization';
import { overviewApi } from './api/overview';
import { questionsApi } from './api/questions';
import { setupApi } from './api/setup';
import { usersApi } from './api/users';

const combinedReducer = combineReducers({
  [organizationApi.reducerPath]: organizationApi.reducer,
  [overviewApi.reducerPath]: overviewApi.reducer,
  [questionsApi.reducerPath]: questionsApi.reducer,
  [leadersApi.reducerPath]: leadersApi.reducer,
  [managementCategoriesApi.reducerPath]: managementCategoriesApi.reducer,
  [managementScheduleApi.reducerPath]: managementScheduleApi.reducer,
  [metadataApi.reducerPath]: metadataApi.reducer,
  [setupApi.reducerPath]: setupApi.reducer,
  [accountSettingsApi.reducerPath]: accountSettingsApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [billingApi.reducerPath]: billingApi.reducer,
});

export const store = configureStore({
  reducer: combinedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(organizationApi.middleware)
      .concat(overviewApi.middleware)
      .concat(questionsApi.middleware)
      .concat(leadersApi.middleware)
      .concat(managementCategoriesApi.middleware)
      .concat(managementScheduleApi.middleware)
      .concat(metadataApi.middleware)
      .concat(setupApi.middleware)
      .concat(accountSettingsApi.middleware)
      .concat(usersApi.middleware)
      .concat(billingApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
